
/* ===== VELANTIS_ELEVA — página de combinaciones (layering) ===== */
(function(){
  var page=document.getElementById('elevaPage'); if(!page) return;
  var grid=document.getElementById('evGrid'), search=document.getElementById('evSearch'), moreBtn=document.getElementById('evMore');
  var elTitle=page.querySelector('.ev-title'), elSub=page.querySelector('.ev-sub');
  function CAT(){ return window.VELANTIS_CAT||[]; }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function de(s){ return String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase(); }
  function hash(s){ var x=2166136261; for(var i=0;i<s.length;i++){ x^=s.charCodeAt(i); x=Math.imul(x,16777619); } return x>>>0; }
  function partner(r){ var c=CAT(), alt=null;
    for(var i=0;i<c.length;i++){ var s=c[i]; if(s[1]==='Ambiental'||s[0]===r[0]) continue;
      if(s[4]!==r[4] && s[1]===r[1]){ if(hash(r[0]+s[0])%7===0){ alt=s; break; } if(!alt) alt=s; } }
    return alt;
  }
  function mini(r){ var key=esc(r[9]||'amaderados');
    return '<div class="ev-mini"><div class="cat-img n-'+key+'"></div><span class="ev-name">'+(r[12]?'<b>'+esc(r[12])+'</b>':'')+esc(r[0])+'</span></div>'; }
  function tipText(r,p){ return p ? ('Aplica <b>'+esc(r[0])+'</b> en muñecas y cuello; remata con <b>'+esc(p[0])+'</b> para una estela más personal e inolvidable.')
                : ('Aplica <b>'+esc(r[0])+'</b> en muñecas y cuello y úsalo generoso para máxima proyección.'); }
  function addBtn(r,p){ return '<button class="ev-add" type="button" data-an="'+esc(r[0])+'" data-ap="'+(r[11]||590)+'" data-ai="n-'+esc(r[9]||'amaderados')+'" data-as="'+esc(r[3]||'')+'"'+
      (p?(' data-bn="'+esc(p[0])+'" data-bp="'+(p[11]||590)+'" data-bi="n-'+esc(p[9]||'amaderados')+'" data-bs="'+esc(p[3]||'')+'"'):'')+'>'+
      (p?'Agregar ambos al carrito':'Agregar al carrito')+'</button>'; }
  function card(r){ var p=partner(r);
    return '<article class="ev-card"><div class="ev-pair">'+mini(r)+'<span class="ev-plus">+</span>'+
      (p?mini(p):'<div class="ev-mini ev-solo">Brilla<br>solo</div>')+'</div><p class="ev-tip">'+tipText(r,p)+'</p>'+addBtn(r,p)+'</article>';
  }
  /* ---- vista DÚO por producto (#/eleva/<nombre>) ---- */
  function priceBig(r){ return (r[1]==='Ambiental')?('$'+(r[11]||449)+' MXN'):('$'+(r[11]||590)+' MXN'); }
  function findRow(id){ id=de(id); return CAT().find(function(r){ return de(r[0])===id || de(r[12]||'')===id; }); }
  function bigCard(r,tag){ var key=esc(r[9]||'amaderados');
    return '<div class="ev-big"><span class="ev-big-tag">'+esc(tag)+'</span><div class="ev-big-img cat-img n-'+key+'"></div>'+
      '<div class="ev-big-info">'+(r[12]?'<span class="ev-big-sku">'+esc(r[12])+'</span>':'')+'<h3>'+esc(r[0])+'</h3>'+
      '<p class="ev-big-fam">'+esc(r[3])+(r[2]?' · Inspirado en '+esc(r[2]):'')+'</p><div class="ev-big-price">'+priceBig(r)+'</div></div></div>'; }
  function setMode(duo){
    if(search) search.style.display=duo?'none':'';
    if(duo && moreBtn) moreBtn.hidden=true;
    grid.classList.toggle('ev-grid-duo', !!duo);
    if(!duo){ if(elTitle) elTitle.textContent='Layering'; if(elSub) elSub.textContent='Combina dos fragancias Velantis y crea una estela única, más personal e inolvidable. Estas son nuestras combinaciones recomendadas para cada aroma.'; }
  }
  function buildDuo(name){
    var r=findRow(name); if(!r){ setMode(false); build(); return; }
    var p=partner(r);
    if(elTitle) elTitle.textContent='Tu Layering';
    if(elSub) elSub.innerHTML='La combinación que eleva <b>'+esc(r[0])+'</b> a otro nivel.';
    setMode(true);
    grid.innerHTML='<div class="ev-duo">'+bigCard(r,'Tu perfume')+'<span class="ev-duo-plus">+</span>'+
      (p?bigCard(p,'Combínalo con'):'<div class="ev-big ev-solo-big"><span class="ev-big-tag">Perfecto solo</span></div>')+'</div>'+
      '<p class="ev-duo-tip">'+tipText(r,p)+'</p><div class="ev-duo-btn">'+addBtn(r,p)+'</div>'+
      '<a class="ev-duo-back" href="#/eleva">Ver todas las combinaciones →</a>';
  }
  var list=[], shown=0, PAGE=24, fSearch='';
  function build(){
    list=CAT().filter(function(r){ return r[1]!=='Ambiental'; });
    if(fSearch) list=list.filter(function(r){ return de((r[0]||'')+' '+(r[2]||'')+' '+(r[12]||'')).indexOf(fSearch)>=0; });
    shown=0; grid.innerHTML=''; renderMore();
  }
  function renderMore(){
    var slice=list.slice(shown, shown+PAGE), html='';
    slice.forEach(function(r){ html+=card(r); });
    grid.insertAdjacentHTML('beforeend', html);
    shown+=slice.length; moreBtn.hidden = shown>=list.length;
    if(!list.length) grid.innerHTML='<p class="ev-solo" style="grid-column:1/-1;padding:30px">Sin resultados · prueba otro nombre.</p>';
  }
  moreBtn.addEventListener('click', renderMore);
  // agregar ambos perfumes de la combinación al carrito
  grid.addEventListener('click', function(e){
    var b=e.target.closest('.ev-add'); if(!b) return;
    var cart=window.VelantisCart; if(!cart||!cart.add) return;
    cart.add({ name:b.getAttribute('data-an'), price:+b.getAttribute('data-ap')||499, img:b.getAttribute('data-ai')||'', sub:b.getAttribute('data-as')||'' });
    if(b.getAttribute('data-bn')) cart.add({ name:b.getAttribute('data-bn'), price:+b.getAttribute('data-bp')||499, img:b.getAttribute('data-bi')||'', sub:b.getAttribute('data-bs')||'' });
    var t=b.textContent; b.textContent='Agregados ✓'; setTimeout(function(){ b.textContent=t; },1500);
    if(cart.open) cart.open();
  });
  var _st; search.addEventListener('input', function(){ clearTimeout(_st); _st=setTimeout(function(){ fSearch=de(search.value.trim()); build(); }, 140); });
  function route(){
    var hs=(location.hash||''); if(hs.length>7 && hs.charAt(hs.length-1)==='/') hs=hs.slice(0,-1);
    var isEv=(hs.indexOf('#/eleva')===0);
    document.body.classList.toggle('eleva', isEv);
    page.hidden=!isEv;                       // vencer [hidden]!important
    if(!isEv) return;
    var focus = hs.length>('#/eleva'.length) ? decodeURIComponent(hs.slice(('#/eleva/').length)) : '';
    if(focus) buildDuo(focus); else { setMode(false); build(); }
    window.scrollTo(0,0);
  }
  window.addEventListener('hashchange', route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded', route);
})();
